import { useEffect, useState } from "react";
import AddressModal from "./AddressModal";
import AddAddressModal from "./AddAddressModal";
import { getCustomerDeliveriesAddressList } from "api/CustomerDeliveries";

interface ShippingInfoProps {
    fullname?: string;
    phone?: string;
    address?: string;
    onUpdateInfo?: (name: string, phone: string, address: string) => void;
    openAddressModalSignal?: number;
}

export default function ShippingInfo({
    fullname = "",
    phone = "",
    address = "",
    onUpdateInfo,
    openAddressModalSignal = 0
}: ShippingInfoProps) {
    const [openAddressModal, setOpenAddressModal] = useState(false);
    const [openAddAddressModal, setOpenAddAddressModal] = useState(false);
    const [editingAddress, setEditingAddress] = useState<any | null>(null);

    useEffect(() => {
        const loadFirstAddress = async () => {
            try {
                const res = await getCustomerDeliveriesAddressList();
                if (!res?.status || !res.data?.items?.length) return;

                const firstAddress = res.data.items[0];
                const fullAddress = `${firstAddress.address}${firstAddress.ward ? `, ${firstAddress.ward}` : ""}${firstAddress.district ? `, ${firstAddress.district}` : ""}${firstAddress.province ? `, ${firstAddress.province}` : ""}`;
                onUpdateInfo?.(firstAddress.name, firstAddress.phone, fullAddress);
            } catch (error) {
                console.error("Failed to load first shipping address", error);
            }
        };

        loadFirstAddress();
    }, []);

    useEffect(() => {
        if (!openAddressModalSignal) return;
        setOpenAddAddressModal(false);
        setOpenAddressModal(true);
    }, [openAddressModalSignal]);

    const handleCloseAddAddress = () => {
        setOpenAddAddressModal(false);
        setOpenAddressModal(true);   // mở lại AddressModal
    };

    return (
        <>
            <div className="MuiPaper-root styles_root__Bo4EW MuiPaper-elevation0 MuiPaper-rounded">
                <h1 className="styles_title__jiXAZ">
                    Thông tin giao hàng
                    <button
                        className="MuiButtonBase-root MuiButton-root MuiButton-text styles_add_new_button__2VFAd"
                        type="button"
                        tabIndex={0}
                    >
                        <span className="MuiButton-label" onClick={() => setOpenAddressModal(true)}>Sửa</span>
                    </button>
                </h1>

                <div className="MuiGrid-root MuiGrid-container">
                    {
                        fullname && phone && address ? (
                            <div className="MuiGrid-root styles_groupInfo__WP9N1 MuiGrid-item MuiGrid-grid-xs-12">

                                {/* Item 1 */}
                                <div className="styles_item__HGoUe">
                                    <div className="flex items-center h-[20px]">
                                        <span
                                            style={{
                                                boxSizing: "border-box",
                                                display: "inline-block",
                                                overflow: "hidden",
                                                width: "initial",
                                                height: "initial",
                                                background: "none",
                                                opacity: 1,
                                                border: 0,
                                                margin: 0,
                                                padding: 0,
                                                position: "relative",
                                                maxWidth: "100%"
                                            }}
                                        >
                                            <span
                                                style={{
                                                    boxSizing: "border-box",
                                                    display: "block",
                                                    width: "initial",
                                                    height: "initial",
                                                    background: "none",
                                                    opacity: 1,
                                                    border: 0,
                                                    margin: 0,
                                                    padding: 0,
                                                    maxWidth: "100%"
                                                }}
                                            >
                                                <img
                                                    alt=""
                                                    aria-hidden="true"
                                                    src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2716%27%20height=%2716%27/%3e"
                                                    style={{
                                                        display: "block",
                                                        maxWidth: "100%",
                                                        width: "initial",
                                                        height: "initial",
                                                        background: "none",
                                                        opacity: 1,
                                                        border: 0,
                                                        margin: 0,
                                                        padding: 0
                                                    }}
                                                />
                                            </span>

                                            <img
                                                src="https://cdn-web-next.thuocsi.vn/icons/checkout/Person.svg"
                                                decoding="async"
                                                style={{
                                                    position: "absolute",
                                                    inset: 0,
                                                    boxSizing: "border-box",
                                                    padding: 0,
                                                    border: "none",
                                                    margin: "auto",
                                                    display: "block",
                                                    width: 0,
                                                    height: 0,
                                                    minWidth: "100%",
                                                    maxWidth: "100%",
                                                    minHeight: "100%",
                                                    maxHeight: "100%"
                                                }}
                                            />
                                        </span>
                                    </div>

                                    <h6 className="MuiTypography-root MuiTypography-h6">
                                        {fullname}
                                    </h6>
                                </div>

                                {/* Item 2 */}
                                <div className="styles_item__HGoUe">
                                    <div>
                                        <span
                                            style={{
                                                boxSizing: "border-box",
                                                display: "inline-block",
                                                overflow: "hidden",
                                                width: "initial",
                                                height: "initial",
                                                background: "none",
                                                opacity: 1,
                                                border: 0,
                                                margin: 0,
                                                padding: 0,
                                                position: "relative",
                                                maxWidth: "100%"
                                            }}
                                        >
                                            <span
                                                style={{
                                                    boxSizing: "border-box",
                                                    display: "block",
                                                    width: "initial",
                                                    height: "initial",
                                                    background: "none",
                                                    opacity: 1,
                                                    border: 0,
                                                    margin: 0,
                                                    padding: 0,
                                                    maxWidth: "100%"
                                                }}
                                            >
                                                <img
                                                    alt=""
                                                    aria-hidden="true"
                                                    src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2716%27%20height=%2716%27/%3e"
                                                    style={{
                                                        display: "block",
                                                        maxWidth: "100%",
                                                        width: "initial",
                                                        height: "initial"
                                                    }}
                                                />
                                            </span>

                                            <img
                                                src="https://cdn-web-next.thuocsi.vn/icons/checkout/Phone.svg"
                                                decoding="async"
                                                style={{
                                                    position: "absolute",
                                                    inset: 0,
                                                    margin: "auto",
                                                    display: "block",
                                                    minWidth: "100%",
                                                    maxWidth: "100%",
                                                    minHeight: "100%",
                                                    maxHeight: "100%"
                                                }}
                                            />
                                        </span>
                                    </div>

                                    <h6 className="MuiTypography-root MuiTypography-h6">
                                        {phone}
                                    </h6>
                                </div>

                                {/* Item 3 */}
                                <div className="styles_item__HGoUe">
                                    <div>
                                        <span
                                            style={{
                                                boxSizing: "border-box",
                                                display: "inline-block",
                                                overflow: "hidden",
                                                width: "initial",
                                                height: "initial",
                                                background: "none",
                                                opacity: 1,
                                                border: 0,
                                                margin: 0,
                                                padding: 0,
                                                position: "relative",
                                                maxWidth: "100%"
                                            }}
                                        >
                                            <span
                                                style={{
                                                    boxSizing: "border-box",
                                                    display: "block",
                                                    width: "initial",
                                                    height: "initial"
                                                }}
                                            >
                                                <img
                                                    alt=""
                                                    aria-hidden="true"
                                                    src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2716%27%20height=%2716%27/%3e"
                                                />
                                            </span>

                                            <img
                                                src="https://cdn-web-next.thuocsi.vn/icons/checkout/Check_In_Pin.svg"
                                                decoding="async"
                                                style={{ position: "absolute", inset: 0, margin: "auto" }}
                                            />
                                        </span>
                                    </div>

                                    <h6 className="MuiTypography-root MuiTypography-h6">
                                        {address}
                                    </h6>
                                </div>

                            </div>
                        ) : (
                            <div className="MuiGrid-root styles_groupInfo__WP9N1 MuiGrid-item MuiGrid-grid-xs-12">
                                <span className="styles_noAddress__2nq8s">Chưa có địa chỉ giao hàng nào</span>
                            </div>
                        )
                    }
                </div>

            </div>
            <AddressModal
                open={openAddressModal}
                onClose={() => setOpenAddressModal(false)}
                onSubmit={(addr) => {
                    onUpdateInfo?.(addr.name, addr.phone, `${addr.address}${addr.ward ? `, ${addr.ward}` : ""}${addr.district ? `, ${addr.district}` : ""}${addr.province ? `, ${addr.province}` : ""}`);
                    setOpenAddressModal(false);
                }}
                onOpenAdd={(address) => {
                    setEditingAddress(address ?? null);
                    setOpenAddressModal(false);
                    setOpenAddAddressModal(true);
                }}
            />
            <AddAddressModal
                open={openAddAddressModal}
                editingAddress={editingAddress}
                onClose={() => {
                    setEditingAddress(null);
                    handleCloseAddAddress() 
                }}
                onSave={() => {
                    // Refresh address list in AddressModal if needed
                    // Actually, AddressModal re-fetches on open
                    setEditingAddress(null);    
                    setOpenAddAddressModal(false);
                    setOpenAddressModal(true);
                }}
            />
        </>
    );
}

